import React, { memo } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { arrayOf, bool, func, instanceOf, number, oneOfType, shape, string } from 'prop-types'

import Card from './Components/Card/Card'
import UploadedModelCard from './Components/UploadedModelCard/UploadedModelCard'

const idType = oneOfType([string, number])

function Grid({
  variations,
  uploadedAsset = null,
  isUploadedModelLoaded,
  openedModelId = null,
  previewedRunId = null,
  mainRunId = null,
  positionById,
  isActionLoading,
  canOpenRelatedTab = false,
  isWide = false,
  showInfo = false,
  onSetAsMain: handleSetAsMain,
  onDelete: handleDelete,
}) {
  // A previewed render is the only selection: it takes the highlight off the model the
  // viewer still shows, uploaded or opened.
  const isPreviewing = previewedRunId != null
  const isActive = id => (isPreviewing
    ? String(id) === String(previewedRunId)
    : !isUploadedModelLoaded && String(id) === String(openedModelId))

  return (
    <div className={classnames('variations-tab__grid', isWide && 'variations-tab__grid--wide')}>
      {uploadedAsset && <UploadedModelCard asset={uploadedAsset} isActive={isUploadedModelLoaded && !isPreviewing} />}
      {variations.map((variation) => (
        <Card
          key={variation.id}
          variation={variation}
          position={positionById.get(String(variation.id))}
          isActive={isActive(variation.id)}
          isMain={mainRunId != null && String(variation.id) === String(mainRunId)}
          isActionLoading={isActionLoading}
          canOpenRelatedTab={canOpenRelatedTab}
          showInfo={showInfo}
          onSetAsMain={handleSetAsMain}
          onDelete={handleDelete}
        />
      ))}
    </div>
  )
}

Grid.propTypes = {
  variations: arrayOf(shape({ id: idType.isRequired })).isRequired,
  uploadedAsset: shape({
    assetId: idType,
    fileUrl: string,
    previewUrl: string,
  }),
  isUploadedModelLoaded: bool.isRequired,
  openedModelId: idType,
  previewedRunId: idType,
  mainRunId: idType,
  positionById: instanceOf(Map).isRequired,
  isActionLoading: bool.isRequired,
  canOpenRelatedTab: bool,
  isWide: bool,
  showInfo: bool,
  onSetAsMain: func.isRequired,
  onDelete: func.isRequired,
}

export default memo(Grid)
